export default "__VITE_PUBLIC_ASSET__8610d813__"